import { useSunmiDefaultPrinterOption } from './hooks/useSunmiDefaultPrinterOption'
import ActionButtons from './parts/ActionButtons'
import FormFields from './parts/FormFields'
import Header from './parts/Header'
import { createAddPrinterData } from './utils/createAddPrinterData'
import { ColorEnum } from '@/constants/color'
import CancelButton from '@/features/common/buttons/CancelButton'
import { ConnectionType } from '@/features/print/constants'
import Form from '@/features/settings/components/AddPrinterModal/form/Provider'
import { OnFormSubmit } from '@/features/settings/components/AddPrinterModal/form/types'
import { OnContinue } from '@/features/settings/components/AddPrinterModal/types'
import { FC } from 'react'
import { ActivityIndicator, ScrollView, StyleSheet, View } from 'react-native'

interface ContentProps {
    onContinue: OnContinue
    onCancel: () => void
}

const Content: FC<ContentProps> = ({ onContinue, onCancel }) => {
    const { printerInfo: sunmiDefaultPrinterInfo, isLoading } = useSunmiDefaultPrinterOption()

    const availableConnectionTypes: ConnectionType[] = sunmiDefaultPrinterInfo
        ? [ConnectionType.SunmiDefault, ConnectionType.Network]
        : [ConnectionType.Network]
    const preferredConnectionType = availableConnectionTypes[0]

    const handleFormSubmit: OnFormSubmit = async (form) => {
        await onContinue(createAddPrinterData(form, sunmiDefaultPrinterInfo))
    }

    return (
        <ScrollView
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="always"
            contentContainerStyle={styles.container}
        >
            <Header />
            {isLoading ? (
                <View style={styles.loadingContainer}>
                    <ActivityIndicator size="large" color={ColorEnum.BLUE_500} />
                    <CancelButton onPress={onCancel} />
                </View>
            ) : (
                <Form preferredConnectionType={preferredConnectionType}>
                    <FormFields availableConnectionTypes={availableConnectionTypes} />
                    <ActionButtons onFormSubmit={handleFormSubmit} onCancel={onCancel} />
                </Form>
            )}
        </ScrollView>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingVertical: 32,
        paddingHorizontal: 16,
        gap: 24,
    },
    loadingContainer: {
        gap: 24,
    },
})

export default Content
